// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piq-body {
  margin: 0;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #515151;
  text-align: left;
  background-color: #010148;
  min-height: 100vh;
}

 .progress-card {
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            width: 400px;
            padding: 60px;
            text-align: center;
        }

        .progress-container {
            position: relative;
            width: 200px;
            height: 200px;
            margin: 0 auto;
        }

        .circular-progress {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            background: conic-gradient(#F8F8F8 0%, #4040DC 0% 100%);
            cursor: grab;
        }

        .inner-circle {
            width: 60%;
            height: 60%;
            background-color: #e4edf4;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
        }

        /*.progress-value {*/
        /*    font-size: 3em;*/
        /*    font-weight: bold;*/
        /*}*/

        .progress-label p {
            margin: 20px 0 0;
            font-size: 1.2em;
            color: #333;
        }

        .indicator {
            position: absolute;
            width: 2px;
            height: 30px;
            background-color: #878787;
            top: 42%;
            left: 50%;
            transform-origin: center bottom;
            cursor: pointer;
        }

        .indicator-value {
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%) rotate(180deg);
            font-size: 15px;
            background-color: transparent;
            color: #878787;
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: 500;
        }

/* Signup and Singin */

.piq-body .card-rounded {
  border-radius: 15px;
}

.piq-body .input-rounded {
  border-radius: 8px;
  background-color: #f8f8f8;
}

.piq-body .button-rounded {
  border-radius: 8px;
  background-color: #4040dd;
}

.piq-body .anchor-button-color {
  color: #4040dd;
  text-decoration: none;
}

.piq-body .anchor-color {
  color: #4040dd;
}

/* dashboard */
/* 
.piq-body nav {
    display: block;
}

.piq-body h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}

.piq-body p {
    margin-top: 0;
    margin-bottom: 1rem;
}

.piq-body a {
    color: #3f84fc;
    text-decoration: none;
    background-color: transparent;
}

.piq-body a:hover {
    color: #0458eb;
    text-decoration: underline;
} */
/* 
.piq-body h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: "IBM Plex Sans", sans-serif;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}

.piq-body h1, .h1 {
    font-size: 2.5rem;
    font-weight: normal;
} */

/* .piq-body .dashboard-app .card {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0;
} */

/* .piq-body .card-body {
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
}

.piq-body .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    text-align: center;
} */

.piq-body .dashboard {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.piq-body .dashboard-app {
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  background: white;
  border-radius: 30px 0px 0px 30px;
}

/* .dashboard-content {
    flex-grow: 2;
    padding: 25px;
} */

.piq-body .dashboard-nav {
  min-width: 238px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  overflow: auto;
  background-color: #010148;
}

/* .piq-body .dashboard-compact .dashboard-nav {
    display: none;
} */

.piq-body .dashboard-nav header {
  display: flex;
  justify-content: center;
  width: 14px;
}

/* .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {
    display: none;
    margin-right: auto;
} */

.piq-body .dashboard-nav a {
  color: #fff;
  text-decoration: none;
}

.piq-body .dashboard-nav a:hover {
  text-decoration: none;
}

.piq-body .campaignInfo-ok-btn {
  color: #fff;
  background-color: #110f75;
  padding: 5px 20px 5px 20px;
  text-align: center;
  border-radius: 7px;
  border: 2px solid #110f75;
  font-weight: 700;
}

.confirmation-modal .modal-dialog > .modal-content {
  padding: 1rem;
  border: 4px solid #2c3e7e !important;
  border-radius: 20px !important;
}
.campaignInfo-modalLabel {
  font-size: 14px;
  font-weight: 600;
}

.campaignInfo-save-btn {
  background-color: #5be7cd;
  color: #1c1c1c;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 500;
  border: 1px solid #5be7cd;
}

.piq-body .campaignInfo-btn-rounded-circle {
  border: 3px solid #2c3e7e !important;
  border-radius: 50px !important;
  font-size: 7px !important;
  margin-top: 10px !important;
  margin-right: 10px !important;
  padding: 6px !important;
}
.piq-body .campaignInfo-btn-rounded-circle.btn-close {
  opacity: 1 !important;
}

/* .piq-body .dashboard-nav {
    background-color: #010148;

} */

.piq-body .dashboard-app .status-pill {
  font-weight: 700;
  font-size: 14px;
  display: inline-block;
  min-width: 150px;
}

.piq-body .dashboard-app .button-bg-warning-danger {
  background-color: #f55f6e;
}
.piq-body .dashboard-app .button-bg-warning {
  background-color: #f5a065;
}
.piq-body .dashboard-app .button-bg-info {
  background-color: #5be7cd;
}

.piq-body .dashboard-app .cl-filter-icon label {
  font-weight: 600;
}

.piq-body .dashboard-app .cl-filter-icon span img {
  max-width: 26px;
  border-radius: 8px;
  margin-right: 7px;
}

.piq-body .dashboard-app .cl-internal-area-container {
  background-color: #f2f5fa;
  border-radius: 15px;
  min-height: calc(100vh - 220px);
}

.piq-body .dashboard-app .cl-heading-border {
  border: 0;
  height: 4px !important;
  background: linear-gradient(to right, #6caad9 28%, #b0c8df 28%);
  margin: 10px 0;
  opacity: 1;
}

.piq-body .dashboard-app .share-square-btn {
  border: none;
  padding: 0;
  color: #4aa2e9;
  background-color: #f5f5f5;
}

.piq-body .dashboard-app .trash-btn {
  border: none;
  padding: 0;
  color: #f55f6e;
  background-color: #f5f5f5;
}

.piq-body .dashboard-app .scroll-area {
  /* height: 450px;
    overflow-x: hidden;*/
  overflow-y: auto;
}

.piq-body .dashboard-app .table td {
  font-weight: 600;
}

/* width */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px transparent;
  border-radius: 5px;
  padding: 20px;
}

/* Handle */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb {
  background: #6caad9;
  border-radius: 10px;
}

/* Handle on hover */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb:hover {
  background: #69b9f6;
}

.campaign-card-rounded {
  border-radius: 12px !important;
  background-color: #cde2f3 !important;
  border: none !important;
}

.campaign-input-rounded {
  border-radius: 8px;
  background-color: #dceaf7;
  font-size: 18px;
  font-weight: 600;
  border: none;
  padding: 10px;
  color: #797979;
}
.campaign-input-rounded:focus {
  outline: none !important;
  border-color: #ccc !important;
  box-shadow: none !important;
}

.campaign-button-rounded {
  background-color: #010148;
  color: #ffffff;
  border-radius: 9px;
  font-weight: 600;
  font-size: 16px;
  padding: 8px;
  border: none;
}

.modal-dialog-custom > .modal-dialog {
  max-width: 350px;
}

.modal-dialog-custom > .modal-dialog > .modal-content {
  border-radius: 20px;
  font-family: "IBM Plex Sans", sans-serif !important;
}

.piq-body .upload-document-text {
  margin-top: 0.25rem;
  font-size: 22px;
  color: #3b3b3b;
  font-weight: 500;
}

.piq-body .new-campaign-heading {
  font-size: 22px;
  font-weight: 600;
}

.piq-body .dashboard-nav .brand-logo {
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  color: #515151;
  align-items: center;
}

.piq-body .dashboard-nav .brand-logo:focus,
.piq-body .dashboard-nav .brand-logo:active,
.piq-body .dashboard-nav .brand-logo:hover {
  color: #dbdbdb;
  text-decoration: none;
}

.piq-body .dashboard-nav .brand-logo i {
  color: #d2d1d1;
  font-size: 27px;
  margin-right: 10px;
}

.piq-body .dashboard-nav-list {
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  display: flex;
  /* -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column; */
  flex-direction: column;
}

.piq-body .dashboard-nav-item {
  min-height: 56px;
  padding: 8px 20px 8px 70px;
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  display: flex;
  /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center; */
  align-items: center;
  letter-spacing: 0.02em;
  transition: ease-out 0.5s;
}

.piq-body .dashboard-nav-item i {
  width: 36px;
  font-size: 19px;
  margin-left: -40px;
}

.piq-body .dashboard-nav-item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.active {
  background: rgba(0, 255, 221, 0.1);
}

.piq-body .dashboard-nav-dropdown {
  display: flex;
  flex-direction: column;
}

.piq-body .dashboard-nav-dropdown.show {
  background: rgba(255, 255, 255, 0.04);
}

.piq-body
  .dashboard-nav-dropdown.show
  > .piq-body
  .dashboard-nav-dropdown-toggle {
  font-weight: bold;
}

.piq-body
  .dashboard-nav-dropdown.show
  > .piq-body
  .dashboard-nav-dropdown-toggle:after {
  transform: none;
}

.piq-body
  .dashboard-nav-dropdown.show
  > .piq-body
  .dashboard-nav-dropdown-menu {
  display: flex;
}

.piq-body .dashboard-nav-dropdown-toggle:after {
  content: "";
  margin-left: auto;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(81, 81, 81, 0.8);
  transform: rotate(90deg);
}

.piq-body .dashboard-nav .piq-body .dashboard-nav-dropdown-toggle:after {
  border-top-color: rgba(255, 255, 255, 0.72);
}

.piq-body .dashboard-nav-dropdown-menu {
  display: none;
  flex-direction: column;
}

.piq-body .dashboard-nav-dropdown-item {
  min-height: 40px;
  padding: 8px 20px 8px 70px;
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  display: flex;
  /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center; */
  align-items: center;
  transition: ease-out 0.5s;
}

.piq-body .dashboard-nav-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.piq-body .dashboard-app .menu-toggle {
  /* position: relative;
    width: 42px;
    height: 42px; */
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  /* display: flex; */
  /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center; */
  /* justify-content: center; */
  color: #443ea2;
}

.piq-body .dashboard-app .menu-toggle:hover,
.piq-body .dashboard-app .menu-toggle:active,
.piq-body .dashboard-app .menu-toggle:focus {
  text-decoration: none;
  color: #875de5;
}

.piq-body .dashboard-app .menu-toggle i {
  font-size: 20px;
}

.piq-body .dashboard-toolbar {
  /*background-color: #dfdfdf;*/
  width: 14px;
  padding: 8px 27px;
  /* min-height: 84px; */
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  /* display: flex; */
  /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center; */

  /* position: fixed; */
  /* top: 0;
    right: 0;
    left: 0;
    z-index: 1000; */
  /* display: none; */
  justify-content: center;
  display: flex;
}

/* .nav-item-divider {
    height: 1px;
    margin: 1rem 0;
    overflow: hidden;
    background-color: rgba(236, 238, 239, 0.3);
} */

/* Basic styling for the drag and drop area */
.piq-body #drag-and-drop-campaign {
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: 2px dashed #f2f5fa;
}

/* Style for the overlay when dragging over */
.piq-body #drag-and-drop-campaign.dragover {
  border: 2px dashed #ccc;
  background-color: #dfdfdf42; /* Light blue overlay */
}

.icon-home {
  width: 36px;
  font-size: 19px;
  margin-left: -40px;
}

.piq-body .top-graph-container .d-heading-type-1
{
	font-size: 40px;
	padding: 10px 0px;
}

.piq-body .top-graph-container .canva_middle_size
{
	max-height:95px;
	height:95px;
	min-height:95px;
	display: flex;
    align-items: center;
    justify-content: center;
}

.piq-body .top-graph-container .chart_canva
{
	max-height:280px!important;
	height:280px!important;
	min-height:280px!important;
}

.piq-body .top-graph-container .chart_canva_doughnut
{
	max-height:200px!important;
	height:200px!important;
	min-height:200px!important;
}
.piq-body .top-graph-container .chart_canva_doughnut_container
{
	max-height:280px!important;
	height:280px!important;
	min-height:280px!important;
	display:flex;
	align-items:center;
}


/* Media Query */

@media (min-width: 991px) {
  .piq-body .dashboard-app {
    margin-left: 238px;
  }

  .piq-body .dashboard-compact .dashboard-app {
    margin-left: 0;
  }
}

@media (max-width: 768px) {
  .piq-body .dashboard-content {
    padding: 15px 0px;
  }
}

@media (max-width: 991px) {
  .piq-body .dashboard-nav {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1070;
  }

  .piq-body .dashboard-nav.mobile-show {
    display: block;
  }

  .piq-body .dashboard-app {
    border-radius: 0px;
  }
}

@media (max-width: 991px) {
  .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {
    /* display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox; */
    display: flex;
  }
}

@media (min-width: 991px) {
  .piq-body .dashboard-app .dashboard-toolbar {
    left: 238px;
  }

  .piq-body .dashboard-compact .dashboard-app .dashboard-toolbar {
    left: 0;
  }
}

@media (min-width: 991px) {
  .piq-body .dashboard-app .dashboard-toolbar {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .piq-body #drag-and-drop-campaign > div.mx-auto.p-4 {
    padding: 0px !important;
  }

  .piq-body #drag-and-drop-campaign .upload-document-text {
    font-size: 14px;
  }

  .piq-body
    #drag-and-drop-campaign
    > div.mx-auto.p-4
    .justify-content-center
    img {
    width: 40px !important;
  }

  .piq-body .dashboard-app .scroll-area.ps-4 {
    padding-left: 0px !important;
  }

  .piq-body .dashboard-app .scroll-area.pe-4 {
    padding-right: 0px !important;
  }

  .piq-body .dashboard-app h3.form-label.text-dark {
    font-size: 18px;
    text-align: center;
  }

  .piq-body .dashboard-app > div.p-4 {
    padding: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;CAEC;YACW,sBAAsB;YACtB,mBAAmB;YACnB,wCAAwC;YACxC,YAAY;YACZ,aAAa;YACb,kBAAkB;QACtB;;QAEA;YACI,kBAAkB;YAClB,YAAY;YACZ,aAAa;YACb,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,kBAAkB;YAClB,uDAAuD;YACvD,YAAY;QAChB;;QAEA;YACI,UAAU;YACV,WAAW;YACX,yBAAyB;YACzB,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,kBAAkB;QACtB;;QAEA,oBAAoB;QACpB,sBAAsB;QACtB,yBAAyB;QACzB,IAAI;;QAEJ;YACI,gBAAgB;YAChB,gBAAgB;YAChB,WAAW;QACf;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,YAAY;YACZ,yBAAyB;YACzB,QAAQ;YACR,SAAS;YACT,+BAA+B;YAC/B,eAAe;QACnB;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,SAAS;YACT,0CAA0C;YAC1C,eAAe;YACf,6BAA6B;YAC7B,cAAc;YACd,gBAAgB;YAChB,mBAAmB;YACnB,gBAAgB;QACpB;;AAER,sBAAsB;;AAEtB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;AACH;;;;;;;;;;;GAWG;;AAEH;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;;;;;;;;GAcG;;AAEH;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,+DAA+D;EAC/D,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;wBACsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,eAAe;EAIf,aAAa;EACb,cAAc;EAId,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;;2BAEyB;EACzB,aAAa;EACb;;;iCAG+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B;;2BAEyB;EACzB,aAAa;EACb;;6BAE2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EAIE,aAAa;EAKb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAME,eAAe;AACjB;;AAEA;;;;EAOE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;EAG3C,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EAKb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B;;2BAEyB;EACzB,aAAa;EACb;;6BAE2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;mBAEiB;EACjB;;2BAEyB;EACzB,mBAAmB;EACnB;;;;;;4BAM0B;EAC1B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB;;2BAEyB;EACzB,mBAAmB;EACnB;;;0BAGwB;;EAExB,qBAAqB;EACrB;;;oBAGkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;;;GAKG;;AAEH,6CAA6C;AAC7C;EACE,eAAe;EACf,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,2BAA2B,EAAE,uBAAuB;AACtD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;CAEC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,eAAe;CACf,WAAW;CACX,eAAe;CACf,aAAa;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;CAEC,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;CAEC,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;AACA;;CAEC,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;CAC1B,YAAY;CACZ,kBAAkB;AACnB;;;AAGA,gBAAgB;;AAEhB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE;;+BAE2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".piq-body {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #515151;\n  text-align: left;\n  background-color: #010148;\n  min-height: 100vh;\n}\n\n .progress-card {\n            background-color: #fff;\n            border-radius: 15px;\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n            width: 400px;\n            padding: 60px;\n            text-align: center;\n        }\n\n        .progress-container {\n            position: relative;\n            width: 200px;\n            height: 200px;\n            margin: 0 auto;\n        }\n\n        .circular-progress {\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n            background: conic-gradient(#F8F8F8 0%, #4040DC 0% 100%);\n            cursor: grab;\n        }\n\n        .inner-circle {\n            width: 60%;\n            height: 60%;\n            background-color: #e4edf4;\n            border-radius: 50%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n        }\n\n        /*.progress-value {*/\n        /*    font-size: 3em;*/\n        /*    font-weight: bold;*/\n        /*}*/\n\n        .progress-label p {\n            margin: 20px 0 0;\n            font-size: 1.2em;\n            color: #333;\n        }\n\n        .indicator {\n            position: absolute;\n            width: 2px;\n            height: 30px;\n            background-color: #878787;\n            top: 42%;\n            left: 50%;\n            transform-origin: center bottom;\n            cursor: pointer;\n        }\n\n        .indicator-value {\n            position: absolute;\n            top: -20px;\n            left: 50%;\n            transform: translateX(-50%) rotate(180deg);\n            font-size: 15px;\n            background-color: transparent;\n            color: #878787;\n            padding: 2px 6px;\n            border-radius: 10px;\n            font-weight: 500;\n        }\n\n/* Signup and Singin */\n\n.piq-body .card-rounded {\n  border-radius: 15px;\n}\n\n.piq-body .input-rounded {\n  border-radius: 8px;\n  background-color: #f8f8f8;\n}\n\n.piq-body .button-rounded {\n  border-radius: 8px;\n  background-color: #4040dd;\n}\n\n.piq-body .anchor-button-color {\n  color: #4040dd;\n  text-decoration: none;\n}\n\n.piq-body .anchor-color {\n  color: #4040dd;\n}\n\n/* dashboard */\n/* \n.piq-body nav {\n    display: block;\n}\n\n.piq-body h1, h2, h3, h4, h5, h6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\n\n.piq-body p {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\n.piq-body a {\n    color: #3f84fc;\n    text-decoration: none;\n    background-color: transparent;\n}\n\n.piq-body a:hover {\n    color: #0458eb;\n    text-decoration: underline;\n} */\n/* \n.piq-body h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n    font-family: \"IBM Plex Sans\", sans-serif;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.piq-body h1, .h1 {\n    font-size: 2.5rem;\n    font-weight: normal;\n} */\n\n/* .piq-body .dashboard-app .card {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0;\n} */\n\n/* .piq-body .card-body {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 1.25rem;\n}\n\n.piq-body .card-header {\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: rgba(0, 0, 0, 0.03);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n    text-align: center;\n} */\n\n.piq-body .dashboard {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n}\n\n.piq-body .dashboard-app {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 2;\n  background: white;\n  border-radius: 30px 0px 0px 30px;\n}\n\n/* .dashboard-content {\n    flex-grow: 2;\n    padding: 25px;\n} */\n\n.piq-body .dashboard-nav {\n  min-width: 238px;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  overflow: auto;\n  background-color: #010148;\n}\n\n/* .piq-body .dashboard-compact .dashboard-nav {\n    display: none;\n} */\n\n.piq-body .dashboard-nav header {\n  display: flex;\n  justify-content: center;\n  width: 14px;\n}\n\n/* .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {\n    display: none;\n    margin-right: auto;\n} */\n\n.piq-body .dashboard-nav a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.piq-body .dashboard-nav a:hover {\n  text-decoration: none;\n}\n\n.piq-body .campaignInfo-ok-btn {\n  color: #fff;\n  background-color: #110f75;\n  padding: 5px 20px 5px 20px;\n  text-align: center;\n  border-radius: 7px;\n  border: 2px solid #110f75;\n  font-weight: 700;\n}\n\n.confirmation-modal .modal-dialog > .modal-content {\n  padding: 1rem;\n  border: 4px solid #2c3e7e !important;\n  border-radius: 20px !important;\n}\n.campaignInfo-modalLabel {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.campaignInfo-save-btn {\n  background-color: #5be7cd;\n  color: #1c1c1c;\n  padding-left: 20px;\n  padding-right: 20px;\n  font-weight: 500;\n  border: 1px solid #5be7cd;\n}\n\n.piq-body .campaignInfo-btn-rounded-circle {\n  border: 3px solid #2c3e7e !important;\n  border-radius: 50px !important;\n  font-size: 7px !important;\n  margin-top: 10px !important;\n  margin-right: 10px !important;\n  padding: 6px !important;\n}\n.piq-body .campaignInfo-btn-rounded-circle.btn-close {\n  opacity: 1 !important;\n}\n\n/* .piq-body .dashboard-nav {\n    background-color: #010148;\n\n} */\n\n.piq-body .dashboard-app .status-pill {\n  font-weight: 700;\n  font-size: 14px;\n  display: inline-block;\n  min-width: 150px;\n}\n\n.piq-body .dashboard-app .button-bg-warning-danger {\n  background-color: #f55f6e;\n}\n.piq-body .dashboard-app .button-bg-warning {\n  background-color: #f5a065;\n}\n.piq-body .dashboard-app .button-bg-info {\n  background-color: #5be7cd;\n}\n\n.piq-body .dashboard-app .cl-filter-icon label {\n  font-weight: 600;\n}\n\n.piq-body .dashboard-app .cl-filter-icon span img {\n  max-width: 26px;\n  border-radius: 8px;\n  margin-right: 7px;\n}\n\n.piq-body .dashboard-app .cl-internal-area-container {\n  background-color: #f2f5fa;\n  border-radius: 15px;\n  min-height: calc(100vh - 220px);\n}\n\n.piq-body .dashboard-app .cl-heading-border {\n  border: 0;\n  height: 4px !important;\n  background: linear-gradient(to right, #6caad9 28%, #b0c8df 28%);\n  margin: 10px 0;\n  opacity: 1;\n}\n\n.piq-body .dashboard-app .share-square-btn {\n  border: none;\n  padding: 0;\n  color: #4aa2e9;\n  background-color: #f5f5f5;\n}\n\n.piq-body .dashboard-app .trash-btn {\n  border: none;\n  padding: 0;\n  color: #f55f6e;\n  background-color: #f5f5f5;\n}\n\n.piq-body .dashboard-app .scroll-area {\n  /* height: 450px;\n    overflow-x: hidden;*/\n  overflow-y: auto;\n}\n\n.piq-body .dashboard-app .table td {\n  font-weight: 600;\n}\n\n/* width */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar {\n  width: 7px;\n}\n\n/* Track */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 2px transparent;\n  border-radius: 5px;\n  padding: 20px;\n}\n\n/* Handle */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb {\n  background: #6caad9;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb:hover {\n  background: #69b9f6;\n}\n\n.campaign-card-rounded {\n  border-radius: 12px !important;\n  background-color: #cde2f3 !important;\n  border: none !important;\n}\n\n.campaign-input-rounded {\n  border-radius: 8px;\n  background-color: #dceaf7;\n  font-size: 18px;\n  font-weight: 600;\n  border: none;\n  padding: 10px;\n  color: #797979;\n}\n.campaign-input-rounded:focus {\n  outline: none !important;\n  border-color: #ccc !important;\n  box-shadow: none !important;\n}\n\n.campaign-button-rounded {\n  background-color: #010148;\n  color: #ffffff;\n  border-radius: 9px;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 8px;\n  border: none;\n}\n\n.modal-dialog-custom > .modal-dialog {\n  max-width: 350px;\n}\n\n.modal-dialog-custom > .modal-dialog > .modal-content {\n  border-radius: 20px;\n  font-family: \"IBM Plex Sans\", sans-serif !important;\n}\n\n.piq-body .upload-document-text {\n  margin-top: 0.25rem;\n  font-size: 22px;\n  color: #3b3b3b;\n  font-weight: 500;\n}\n\n.piq-body .new-campaign-heading {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.piq-body .dashboard-nav .brand-logo {\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-weight: bold;\n  font-size: 20px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  color: #515151;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.piq-body .dashboard-nav .brand-logo:focus,\n.piq-body .dashboard-nav .brand-logo:active,\n.piq-body .dashboard-nav .brand-logo:hover {\n  color: #dbdbdb;\n  text-decoration: none;\n}\n\n.piq-body .dashboard-nav .brand-logo i {\n  color: #d2d1d1;\n  font-size: 27px;\n  margin-right: 10px;\n}\n\n.piq-body .dashboard-nav-list {\n  /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n  display: flex;\n  /* -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column; */\n  flex-direction: column;\n}\n\n.piq-body .dashboard-nav-item {\n  min-height: 56px;\n  padding: 8px 20px 8px 70px;\n  /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n  display: flex;\n  /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center; */\n  align-items: center;\n  letter-spacing: 0.02em;\n  transition: ease-out 0.5s;\n}\n\n.piq-body .dashboard-nav-item i {\n  width: 36px;\n  font-size: 19px;\n  margin-left: -40px;\n}\n\n.piq-body .dashboard-nav-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.active {\n  background: rgba(0, 255, 221, 0.1);\n}\n\n.piq-body .dashboard-nav-dropdown {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.piq-body .dashboard-nav-dropdown.show {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.piq-body\n  .dashboard-nav-dropdown.show\n  > .piq-body\n  .dashboard-nav-dropdown-toggle {\n  font-weight: bold;\n}\n\n.piq-body\n  .dashboard-nav-dropdown.show\n  > .piq-body\n  .dashboard-nav-dropdown-toggle:after {\n  -webkit-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n.piq-body\n  .dashboard-nav-dropdown.show\n  > .piq-body\n  .dashboard-nav-dropdown-menu {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.piq-body .dashboard-nav-dropdown-toggle:after {\n  content: \"\";\n  margin-left: auto;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid rgba(81, 81, 81, 0.8);\n  -webkit-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.piq-body .dashboard-nav .piq-body .dashboard-nav-dropdown-toggle:after {\n  border-top-color: rgba(255, 255, 255, 0.72);\n}\n\n.piq-body .dashboard-nav-dropdown-menu {\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.piq-body .dashboard-nav-dropdown-item {\n  min-height: 40px;\n  padding: 8px 20px 8px 70px;\n  /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n  display: flex;\n  /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center; */\n  align-items: center;\n  transition: ease-out 0.5s;\n}\n\n.piq-body .dashboard-nav-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.piq-body .dashboard-app .menu-toggle {\n  /* position: relative;\n    width: 42px;\n    height: 42px; */\n  /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n  /* display: flex; */\n  /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center; */\n  /* justify-content: center; */\n  color: #443ea2;\n}\n\n.piq-body .dashboard-app .menu-toggle:hover,\n.piq-body .dashboard-app .menu-toggle:active,\n.piq-body .dashboard-app .menu-toggle:focus {\n  text-decoration: none;\n  color: #875de5;\n}\n\n.piq-body .dashboard-app .menu-toggle i {\n  font-size: 20px;\n}\n\n.piq-body .dashboard-toolbar {\n  /*background-color: #dfdfdf;*/\n  width: 14px;\n  padding: 8px 27px;\n  /* min-height: 84px; */\n  /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n  /* display: flex; */\n  /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center; */\n\n  /* position: fixed; */\n  /* top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1000; */\n  /* display: none; */\n  justify-content: center;\n  display: flex;\n}\n\n/* .nav-item-divider {\n    height: 1px;\n    margin: 1rem 0;\n    overflow: hidden;\n    background-color: rgba(236, 238, 239, 0.3);\n} */\n\n/* Basic styling for the drag and drop area */\n.piq-body #drag-and-drop-campaign {\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border: 2px dashed #f2f5fa;\n}\n\n/* Style for the overlay when dragging over */\n.piq-body #drag-and-drop-campaign.dragover {\n  border: 2px dashed #ccc;\n  background-color: #dfdfdf42; /* Light blue overlay */\n}\n\n.icon-home {\n  width: 36px;\n  font-size: 19px;\n  margin-left: -40px;\n}\n\n.piq-body .top-graph-container .d-heading-type-1\n{\n\tfont-size: 40px;\n\tpadding: 10px 0px;\n}\n\n.piq-body .top-graph-container .canva_middle_size\n{\n\tmax-height:95px;\n\theight:95px;\n\tmin-height:95px;\n\tdisplay: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.piq-body .top-graph-container .chart_canva\n{\n\tmax-height:280px!important;\n\theight:280px!important;\n\tmin-height:280px!important;\n}\n\n.piq-body .top-graph-container .chart_canva_doughnut\n{\n\tmax-height:200px!important;\n\theight:200px!important;\n\tmin-height:200px!important;\n}\n.piq-body .top-graph-container .chart_canva_doughnut_container\n{\n\tmax-height:280px!important;\n\theight:280px!important;\n\tmin-height:280px!important;\n\tdisplay:flex;\n\talign-items:center;\n}\n\n\n/* Media Query */\n\n@media (min-width: 991px) {\n  .piq-body .dashboard-app {\n    margin-left: 238px;\n  }\n\n  .piq-body .dashboard-compact .dashboard-app {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .piq-body .dashboard-content {\n    padding: 15px 0px;\n  }\n}\n\n@media (max-width: 991px) {\n  .piq-body .dashboard-nav {\n    display: none;\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 1070;\n  }\n\n  .piq-body .dashboard-nav.mobile-show {\n    display: block;\n  }\n\n  .piq-body .dashboard-app {\n    border-radius: 0px;\n  }\n}\n\n@media (max-width: 991px) {\n  .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {\n    /* display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox; */\n    display: flex;\n  }\n}\n\n@media (min-width: 991px) {\n  .piq-body .dashboard-app .dashboard-toolbar {\n    left: 238px;\n  }\n\n  .piq-body .dashboard-compact .dashboard-app .dashboard-toolbar {\n    left: 0;\n  }\n}\n\n@media (min-width: 991px) {\n  .piq-body .dashboard-app .dashboard-toolbar {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .piq-body #drag-and-drop-campaign > div.mx-auto.p-4 {\n    padding: 0px !important;\n  }\n\n  .piq-body #drag-and-drop-campaign .upload-document-text {\n    font-size: 14px;\n  }\n\n  .piq-body\n    #drag-and-drop-campaign\n    > div.mx-auto.p-4\n    .justify-content-center\n    img {\n    width: 40px !important;\n  }\n\n  .piq-body .dashboard-app .scroll-area.ps-4 {\n    padding-left: 0px !important;\n  }\n\n  .piq-body .dashboard-app .scroll-area.pe-4 {\n    padding-right: 0px !important;\n  }\n\n  .piq-body .dashboard-app h3.form-label.text-dark {\n    font-size: 18px;\n    text-align: center;\n  }\n\n  .piq-body .dashboard-app > div.p-4 {\n    padding: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
